/* Ciano · fechas de entrega, aviso de cierre, fecha en la cesta y «Completa tu pedido» propio */
(function () {
  var CE = window.CianoEntrega;

  /* ---------- Entrega en la ficha ---------- */
  function textoFicha() {
    var r = CE.calc();
    if (r.hoy) {
      var min = Math.max(1, Math.round(r.resta / 60000)), h = Math.floor(min / 60), m = min % 60;
      var queda = h ? h + ' h ' + (m ? m + ' min' : '') : m + ' min';
      return (window.CIANO_EN ? 'Order within the next ' : window.CIANO_CA ? 'Demana-ho en les properes ' : 'Pide en las próximas ') + queda.trim() + (window.CIANO_EN ? " and we'll get it ready today: you'll receive it " : window.CIANO_CA ? ' i el preparem avui: el reps ' : ' y lo preparamos hoy: lo recibes ') + CE.rango(r);
    }
    return (window.CIANO_EN ? "We'll get it ready on " : window.CIANO_CA ? 'El preparem el ' : 'Lo preparamos el ') + CE.fc(r.prep) + (window.CIANO_EN ? " and you'll receive it " : window.CIANO_CA ? ' i el reps ' : ' y lo recibes ') + CE.rango(r);
  }
  function pintaFicha() {
    if (!CE) return;
    var t = textoFicha();
    document.querySelectorAll('[data-ce-txt]').forEach(function (e) { if (e.textContent !== t) e.textContent = t; });
  }

  /* ---------- Aviso de cierre del obrador ---------- */
  function pintaAviso() {
    if (!CE) return;
    var t = CE.aviso();
    document.querySelectorAll('[data-ce-aviso]').forEach(function (e) {
      if (!t) { e.hidden = true; return; }
      e.querySelector('[data-ce-aviso-txt]').textContent = t;
      e.hidden = false;
    });
  }

  /* ---------- Fecha en la cesta + atributo del pedido ---------- */
  var guardando = false;
  function pintaCesta() {
    if (!CE) return;
    var els = document.querySelectorAll('[data-ce-cesta]');
    if (!els.length) return;
    var r = CE.calc(), val = CE.rango(r);
    var txt = (window.CIANO_EN ? 'Estimated delivery in mainland Spain: ' : window.CIANO_CA ? 'Lliurament estimat a la península: ' : 'Entrega estimada en península: ') + val + '.';
    els.forEach(function (e) { if (e.textContent !== txt) e.textContent = txt; });
    var e0 = els[0];
    if (e0.dataset.vacia === 'true' || guardando) return;
    var ves = CE.rangoEs ? CE.rangoEs(r) : val, nuevo = ves.charAt(0).toUpperCase() + ves.slice(1);
    if (e0.dataset.attr === nuevo) return;
    guardando = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Entrega estimada': nuevo } })
    }).then(function () { els.forEach(function (e) { e.dataset.attr = nuevo; }); }).catch(function () {}).finally(function () { guardando = false; });
  }

  /* ---------- «Completa tu pedido» en la cesta lateral ---------- */
  var cache = {};
  function llenaSugerencias() {
    document.querySelectorAll('[data-ciano-sug]:not([data-hecho])').forEach(function (slot) {
      var pid = slot.dataset.pid, en = (slot.dataset.enCesta || '').split(',');
      if (!pid) return;
      slot.dataset.hecho = '1';
      var titulo = slot.dataset.titulo;
      var poner = function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var bloque = tmp.querySelector('.ciano-sug');
        if (!bloque) return;
        var n = 0;
        bloque.querySelectorAll('.ciano-sug__i').forEach(function (li) {
          if (en.indexOf(li.dataset.pid) >= 0 || n >= 3) li.remove(); else n++;
        });
        if (!n) return;
        var mol = (slot.dataset.molienda || '').toLowerCase();
        if (mol) bloque.querySelectorAll('select').forEach(function (s) {
          for (var i = 0; i < s.options.length; i++) { var t = s.options[i].text.toLowerCase();
            if (t.indexOf(mol) >= 0 && /^250/.test(t)) { s.selectedIndex = i; break; } }
        });
        if (titulo) bloque.querySelector('.ciano-sug__t').textContent = titulo;
        slot.innerHTML = ''; slot.appendChild(bloque);
      };
      if (cache[pid]) return poner(cache[pid]);
      var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      fetch(root + 'recommendations/products?section_id=ciano-cesta-sugerencias&product_id=' + pid + '&limit=8&intent=related')
        .then(function (r) { return r.text(); })
        .then(function (html) { cache[pid] = html; poner(html); })
        .catch(function () {});
    });
  }
  document.addEventListener('submit', function (ev) {
    var f = ev.target.closest && ev.target.closest('.ciano-sug__f');
    if (!f) return;
    ev.preventDefault();
    var btn = f.querySelector('button'); btn.disabled = true; btn.textContent = (window.CIANO_EN ? 'Adding…' : window.CIANO_CA ? 'Afegint…' : 'Añadiendo…');
    var id = f.querySelector('[name="id"]').value;
    var drawer = document.querySelector('cart-drawer');
    var secciones = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: secciones, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { btn.textContent = (window.CIANO_EN ? 'Sold out' : window.CIANO_CA ? 'Esgotat' : 'Sin stock'); return; }
      if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
      if (drawer && drawer.renderContents) drawer.renderContents(res);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ciano-sug', cartData: res });
    }).catch(function () { btn.disabled = false; btn.textContent = (window.CIANO_EN ? 'Add' : window.CIANO_CA ? 'Afegeix' : 'Añadir'); });
  });

  /* ---------- Arranque y cambios de la cesta ---------- */
  function pintaTueste() {
    if (!CE || !CE.tueste) return;
    document.querySelectorAll('[data-ce-tueste]').forEach(function (b) {
      var t = CE.tueste(b.dataset.propia), li = b.closest('[data-ce-tueste-li]');
      if (t) { b.textContent = t; if (li) li.hidden = false; }
    });
  }
  function todo() { pintaTueste(); pintaFicha(); pintaAviso(); pintaCesta(); llenaSugerencias(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo); else todo();
  setInterval(pintaFicha, 60000);
  var pend = 0;
  new MutationObserver(function () {
    if (pend) return;
    pend = requestAnimationFrame(function () { pend = 0; pintaCesta(); llenaSugerencias(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
